import React, { Component } from 'react';
import Axios from 'axios';
import { withRouter } from 'react-router-dom';
import './TopBar.css';

import Config from '../../../base/config/Config';
import Session from '../../../base/Session';
import Utils from '../../../base/Utils';

import Logo from '../../../resources/images/logo.png';
import Button from '../button/Button';
import Label from '../label/Label';
import ProfilePic from '../profilePic/ProfilePic';
import Icon from '../icon/Icon';
import SmallText from '../smallText/SmallText';
import Loading from '../loading/Loading';

class TopBar extends Component {
    constructor(props) {
        super(props);
        
        Session.setCallback(() => this.checkLogin());
        
        this.state = {session: Session.getParams()};
    }
    
    buttons = [
        {
            text: "Documentation",
            to: "/documentation"
        },
        {
            text: "Control Panel",
            to: "/control-panel"
        },
        {
            text: "Management",
            to: "/management"
        },
        {
            text: "Feedback",
            to: "/feedback"
        }
    ];
    
    render() {
        var apiStatus = this.state.session.apiStatus;
        var isLoggedIn = this.state.session.isLoggedIn;
        var id = this.state.session.id;
        var photo = this.state.session.photo;
        //var name = this.state.session.name;
        var member = this.state.session.member;
        var teams = this.state.session.teams;
        
        var data = Utils.getAPIStatusLayout(apiStatus);
        
        var apiStatusText = "API " + data.text.toUpperCase();
        var apiStatusColor = data.color;
        
        return <div className="TopBar">
        <div className="LeftSide">
        <img className="Logo" src={Logo} alt="Swonkie Logo" />
        <div className="LogoText">Developers</div>
        </div>
        {this.buttonsPlace()}
        <div className="RightSide">
        {(apiStatus === null) ? <Loading /> : <Label text={apiStatusText} type={apiStatusColor} />}
        {
            (isLoggedIn) ?
            <div className="Menu">
            <ProfilePic src={photo} size="Big" />
            <Icon color="Light" size="Medium" set="Dropdown" />
            <div className="MenuDropdown">
            <SmallText text="You" />
            <Button text={member.name} type="Clean Discreet" size="Small" state={(id === member.id) ? "Disabled" : ""}
            onClick={() => this.changeTeam(member.id)} />
            {
                (teams && teams !== null) ?
                <span style={{width:'100%'}}>
                <SmallText text="Teams" />
                {
                    teams.map((team, key) => {
                        return <Button key={key} text={team.name} type="Clean Discreet" size="Small" state={(id === team.id) ? "Disabled" : ""}
                        onClick={() => this.changeTeam(team.id)} />;
                    })
                }
                </span>
                : ''
            }<br />
            <Button text="Back to Swonkie" type="Clean Discreet" size="Small" to={Config.mainHost} />
            <Button text="Logout" type="Clean Discreet" size="Small" onClick={() => Session.logout()} />
            </div>
            </div>
            :
            <Button text="LOGIN" onClick={() => Utils.reloadPage(Utils.getLoginUrl()) } type="Clean Normal" />
        }
        </div>
        </div>;
    }
    
    changeTeam(id) {
        Axios.post(Config.mainHost + "php/team_manager.php", {change_user: id}).then((response) => {
            if(parseInt(response) === 1) {
                window.top.location.reload();
            }
        });
    }
    
    checkLogin() {
        this.setState({
            session: Session.getParams()
        });
    }
    
    buttonsPlace() {
        return <div className="ButtonsPlace">
        {this.buttons.map((value) => {
            return <Button text={value.text} to={value.to} state={this.checkToActive(value.to)} type="Clean Discreet" />;
        })}
        </div>;
    }
    
    checkToActive(to) {
        return (to === this.props.location.pathname) ? 'Active' : '';
    }
}

export default withRouter(TopBar);
